__turbopack_context__.v({
  "container": "payment-header-module-scss-module__of1dKW__container",
  "logoSection": "payment-header-module-scss-module__of1dKW__logoSection",
  "wrapper": "payment-header-module-scss-module__of1dKW__wrapper",
});
